import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { SUBSCRIPTION_ENDPOINT } from './endpoints';

const actions = createActions({
  PAYMENT: {
    GET_BUSINESS_STRIPE_SUBSCRIPTION: (businessId) => ({ businessId }),
    API: {
      GET_BUSINESS_STRIPE_SUBSCRIPTION: apiResourceActionCreator('stripeSubscription'),
    },
  },
});

export const apiAction = (authToken, businessId) => commonApiActions.authenticated.get(`${SUBSCRIPTION_ENDPOINT}/${businessId}`, authToken, actions.payment.api.getBusinessStripeSubscription);

export function* fetchSubscription(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.businessId));
};

const configuration = {
  name: 'getBusinessStripeSubscription',
  action: actions,
  sagas: fetchSubscription,
  reducers: {
    request: (state, _) => ({
      ...state,
      isFetching: true,
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      stripeSubscription: action.payload.stripeSubscription,
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      error: action.payload.error,
    }),
  },
};

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/payment/configurations/getBusinessStripeSubscription.js